namespace advisorop.components.widgets {
    
    export class TopHoldingsController{
        public topNHoldings: domains.IChartDataSource;
        n: number;
        public asOfDate;
        public dgTopNHoldings: DevExpress.ui.dxDataGridOptions = {
            export: {
                enabled: true,
                fileName: "TopHoldings"
            },
            bindingOptions: {
                dataSource: "vm.topNHoldings.data"
            },
            scrolling: {
                useNative: true,
            },
            paging: { pageSize: 10 },
//            height: "226px", // TODO: convert this to function, must be calculated
            rowAlternationEnabled: true,
            showColumnLines: false,
            selection: {
                mode: 'single'
            },
            columns: [
                { dataField: 'label', caption: 'Holding' },
                { dataField: 'value', caption: 'USD Value', width: 110, format: { type: 'fixedPoint', precision: 2 } }
            ],
            onRowClick: (e) => {
                const data: {
                    bySecurityTypes: string, id: number, label: string, label2: string
                    value: number, value2: number, value3: number
                } = e.data;

                //// Label2 contains UniqueSecurityId
                //if (data && data.label2) {
                //    this.selectFilterSecurityCodeCtl.selectedSymbol = null;
                //    this.selectFilterSecurityCodeCtl.setSymbolText({
                //        uniqueSecId: data.label2,
                //        name: data.label,
                //        id: 0
                //    });
                //    this.selectFilterSecurityCodeCtl.loadAccountsBySecId(data.label2);
                //}
            }
        };

        
        constructor(private advisorService: services.AdvisorService, private $rootScope: ng.IRootScopeService) { 
            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.loadTopNHoldings();
            });
        }

        loadTopNHoldings()
        {
            // console.log(`Loading TopNHoldings n:${this.n}, asOfDate:${this.asOfDate}`);
            const adminMode = this.advisorService.getAdminMode();
            const adminModeEnabled = adminMode && adminMode.enabled;
            this.advisorService.getTopNHoldingsByAdvisor(adminModeEnabled, adminModeEnabled && adminMode.advisoryFirm ? adminMode.advisoryFirm.id : null, this.n)
                .then(data => {
                    this.topNHoldings = data.data;
                    this.asOfDate = this.topNHoldings.asOfDt;
            }, err => toastr.error("TOP N Holdings error: " + err.status + ":" + err.data));
        }
        
        $onInit(): void {
            if (!this.n) {
                this.loadTopNHoldings();
            }
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "n") {
                    if (this.n) {
                        this.loadTopNHoldings();
                    }
                }
            }
        }

        $routerOnActivate(next, previous) {
            
        }

    }



    class TopHoldings implements ng.IComponentOptions {

        public transclude: boolean;
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                n: "<",
                asOfDate: "="
            };
            this.controller = ["advisorService","$rootScope", TopHoldingsController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/top-holdings.html';
            this.transclude = false;
        }
    }
    angular.module(Constants.APP).component("topHoldings", new TopHoldings());
    
}